import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isEqual } from 'lodash';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { CheckBoxRounded, InputSize } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'request-list-filter',
  templateUrl: './request-list-filter.component.html',
  styleUrls: ['./request-list-filter.component.scss'],
  standalone: false,
})
export class RequestListFilterComponent implements OnInit {
  @Input() modalFilters: app.models.GetRequestsModelPageFilter = {
    statusesIds: [],
  } as app.models.GetRequestsModelPageFilter;
  @Input() initialFilterState: app.models.GetRequestsModelPageFilter = {
    statusesIds: [],
  } as app.models.GetRequestsModelPageFilter;
  @Input() modalRequestsStatuses: app.models.DictionaryDataModel[] = [];
  public roundedLarge: CheckBoxRounded = 'large';
  public size: InputSize = 'large';
  requestsStatuses: app.models.DictionaryDataModelWithCheckbox[] = [];

  public constructor(private _activeModal: NgbActiveModal) {}

  public ngOnInit(): void {
    this.requestsStatuses = this.modalRequestsStatuses.map(x => ({
      id: x.id,
      value: x.value,
      code: x.code,
      isSelected: this.modalFilters.statusesIds.includes(x.id),
    }));
  }

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.requestsStatuses = this.requestsStatuses.map(x => (x = { ...x, isSelected: false }));
    this.modalFilters.statusesIds = [];

    this._activeModal.close(isEqual(this.modalFilters, this.initialFilterState) ? false : 0);
  }

  public applyFilterHandler() {
    this.modalFilters.statusesIds = this.requestsStatuses.filter(x => x.isSelected).map(x => x.id);
    let filterCount = this.modalFilters.statusesIds.length;

    this._activeModal.close(isEqual(this.modalFilters, this.initialFilterState) ? false : filterCount);
  }
}
